<div *ngIf="userForm" [formGroup]="userForm">
  <p-toast></p-toast>
  New User
  <div>
    *username
    <input formControlName="username">
  </div>
  <div>
    *password
    <input type="password" formControlName="password">
  </div>
  <div>
    email
    <input formControlName="email">
  </div>
  <div>
    slack ID
    <input formControlName="slackId">
  </div>
  <div formArrayName="roles" *ngFor="let role of roles; let i = index">
    {{role}}
    <p-checkbox [formControlName]="i" [binary]="true"></p-checkbox>
  </div>
  <div>
    <button [disabled]="userForm.invalid" (click)="sendForm()">Submit</button>
  </div>
</div>
<div>
  For security reasons, password should:
  <p>
    contain at least 1 lowercase alphabetical character
  </p>
  <p>
    contain at least 1 uppercase alphabetical character
  </p>
  <p>
    contain at least 1 numeric character
  </p>
  <p>
    contain at least one special character
  </p>
  <p>
    be 8 characters or longer
  </p>
</div>